<template>
  <div class="trow" :class="colorTheme">
    <i class="icon-state" :class="iconType" @click="check"></i>
    <div class="trow__data">
      <div class="trow__names" @click="$emit('setCurrentTRegister',data.id)">
        {{data.firstSurname}}
        {{data.secondSurname}}, {{data.firstName | firstName}}
      </div>
      <div class="trow__dni" @click="$emit('setCurrentTRegister',data.id)">{{data.documentNumber}}</div>
      <div class="trow__state"></div>
    </div>
    <div class="trow__tools" v-if="$store.getters.canWrite">
      <i class="icon-edit" @click="$emit('setCurrentTRegister',data.id)"></i>
      <i class="icon-close" @click="$emit('deleteTRegister',data)"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    noTareo: {
      type: Boolean
    },
    allchecked: {
      type: Boolean
    }
  },
  data() {
    return {
      isCheck: false
    };
  },
  watch: {
    allchecked(newValue, oldValue){
      if(newValue){
        this.isCheck = true
      }else {
        this.isCheck = false
      }
    }
  },
  computed: {
    iconType() {
      if (!this.data.isComplete) {
        if (this.isCheck) return "icon-check-circle";
        return "icon-exclamation-circle";
      } else return "icon-check-circle";
    },
    colorTheme() {
      if (!this.data.isComplete) {
        if (this.isCheck) return "theme-blue";
        else return "theme-yellow";
      } else {
        if (this.isCheck) return "theme-blue";
        else return "theme-green";
      }
    }
  },
  methods: {
    check() {
      if (this.noTareo) {
        this.isCheck = !this.isCheck;
        this.$emit("check", {id: this.data.id, flag: this.isCheck});
      }
    }
  },
  filters: {
    firstName(value) {
      if (window.innerWidth < 1200 && String(value).search(" ") != -1)
        return String(value).slice(0, value.search(" "));
      else return value;
    }
  }
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";
//maps
$yellow: (
  "light": #d8ff00,
  "dark": #d8ff00,
  "content": "POR COMPLETAR"
);
$green: (
  "light": #97c2c9,
  "dark": #97c2c9,
  "content": "COMPLETADO"
);
$blue: (
  "light": #97c2c9,
  "dark": #97c2c9,
  "content": "SELECCIONADO"
);

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

@mixin theme($color) {
  $light: map-get($color, "light");
  $dark: map-get($color, "dark");

  border-left: 9px solid $light;
  background-color: rgba($light, 0.25);
  .icon-state {
    color: $light;
  }

  .trow {
    &__names {
      color: #2c2c2c;
    }
    &__dni {
      color: $dark;
    }
    &__state {
      background-color: rgba($light, 0.8);
      &::before {
        content: map-get($color, "content");
        color: #2c2c2c;
      }
    }
    &__tools {
      color: $dark;
    }
  }
}

//7-TRUMPS
.theme {
  &-yellow {
    @include theme($yellow);
  }
  &-green {
    @include theme($green);
  }
  &-blue {
    @include theme($blue);
  }
}

.trow {
  width: 24rem;
  height: 8rem;
  display: flex;
  justify-content: space-between;
  margin: 1rem auto;
  padding: 1rem 0.5rem 0 0.5rem;
  border-radius: 9px;

  @include mq($lg) {
    width: 100%;
    height: 4rem;
    margin: 0.5rem 0;
    padding: 0 0.5rem;
    justify-content: flex-start;
  }

  .icon-state {
    font-size: 3rem;
    &::before {
      line-height: 4rem;
    }
  }
  &__data {
    display: flex;
    flex-wrap: wrap;
    margin-left: 0.6rem;
    @include mq($lg) {
      align-items: center;
      width: 89%;
      margin-left: 2rem;
    }
  }
  &__names {
    font-weight: 600;
    text-transform: capitalize;
    @include mq($lg) {
      width: 45%;
      font-size: 1.1rem;
      cursor: pointer;
    }
  }
  &__dni {
    display: none;
    @include mq($lg) {
      display: block;
      width: 21%;
      font-size: 1.1rem;
      cursor: pointer;
    }
  }
  &__state {
    width: 15rem;
    height: 3rem;
    border-radius: 9px;
    position: relative;
    &::before {
      position: absolute;
      font-size: 1.1rem;
      font-weight: 700;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      text-align: center;
    }
    @include mq($lg) {
      width: 12.5rem;
      height: 2.5rem;
    }
  }
  &__tools {
    font-size: 1.2rem;
    .icon-edit {
      margin-right: 0.3rem;
      @include mq($lg) {
        margin-right: 0.6rem;
      }
    }
    @include mq($lg) {
      font-size: 1.8rem;
      line-height: 4rem;
      cursor: pointer;
    }
  }
}
</style>
